import { Route } from '@angular/router';
import { AuthCallbackComponent } from '@vasta/client-core-authentication';
import { authGuard } from '@vasta/frontend-shared-core-authentication';
import { AuthenticatedLayoutComponent } from './authenticated-layout.component';
import { tenantRedirectGuard } from './tenant-redirect.guard';
import { tenantValidGuard } from './tenant-valid.guard';

export const appRoutes: Route[] = [
  { path: 'auth/callback', component: AuthCallbackComponent },
  {
    path: 'p/:slug',
    loadComponent: () =>
      import('@vasta/client-feature-scheduling').then(
        (m) => m.PublicSchedulePage,
      ),
  },
  {
    path: '',
    component: AuthenticatedLayoutComponent,
    children: [
      {
        path: '',
        canActivate: [authGuard, tenantRedirectGuard],
        children: [],
      },
      {
        path: 'tenants',
        canActivate: [authGuard],
        children: [
          {
            path: 'new',
            loadChildren: () =>
              import('@vasta/client-feature-onboarding').then(
                (m) => m.clientFeatureOnboardingRoutes,
              ),
          },
        ],
      },
      {
        path: ':tenantId',
        canActivate: [authGuard, tenantValidGuard],
        children: [
          {
            path: 'scheduling',
            loadChildren: () =>
              import('@vasta/client-feature-scheduling').then(
                (m) => m.clientFeatureSchedulingRoutes,
              ),
          },
          {
            path: 'settings',
            loadChildren: () =>
              import('@vasta/client-feature-settings').then(
                (m) => m.clientFeatureSettingsRoutes,
              ),
          },
          {
            path: 'profile',
            loadChildren: () =>
              import('@vasta/client-feature-profile').then(
                (m) => m.clientFeatureProfileRoutes,
              ),
          },
          {
            path: 'onboarding',
            loadChildren: () =>
              import('@vasta/client-feature-onboarding').then(
                (m) => m.clientFeatureOnboardingTenantRoutes,
              ),
          },
          { path: '', redirectTo: 'scheduling', pathMatch: 'full' },
          {
            path: 'operators/:id',
            outlet: 'dialog',
            loadComponent: () =>
              import('@vasta/client-feature-settings').then(
                (m) => m.OperatorsEditPage,
              ),
          },
          {
            path: 'working-turns/:id',
            outlet: 'dialog',
            loadComponent: () =>
              import('@vasta/client-feature-settings').then(
                (m) => m.WorkingTurnsEditPage,
              ),
          },
        ],
      },
    ],
  },
];
